import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
// --- MUDANÇA: getAnalytics e logEvent removidos dos imports automáticos
import { getAnalytics } from "firebase/analytics"; 
import { getAuth, signInAnonymously, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";


const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);

export const db = getDatabase(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// --- NOVO: Variável global para armazenar a instância do Analytics
let analyticsInstance = null;

// --- NOVO: Função para inicializar o Analytics apenas APÓS o consentimento
export const initializeAnalytics = () => {
  if (!analyticsInstance) {
    analyticsInstance = getAnalytics(app);
  }
  return analyticsInstance;
};

// --- MUDANÇA: Exporta logEvent diretamente (sem a instância)
export { logEvent } from "firebase/analytics"; 


export const anonSignIn = async () => {
  try {
    const userCredential = await signInAnonymously(auth);
    return userCredential.user;
  } catch (error) {
    console.error("Anonymous sign-in failed:", error);
    return null;
  }
};

export { signInWithPopup, signOut, onAuthStateChanged };